import styled, { css } from 'styled-components';
import { spacingOptions, lineHeightOptions } from '../utils/utils';
import media from '../media';

const baseHeading = css`
	line-height: 1.4;
	color: ${props => props.theme.colors.black};
	${spacingOptions};
	${lineHeightOptions};
`;

const asHeading1 = css`
	${baseHeading}
	font-size: 2.4rem;
	font-weight: 900;
	line-height: 2.8rem;

	${media.tablet`
		font-size: 2.6rem;
		line-height: 3rem;
	`};

	${media.desktopSmall`
		font-size: 3rem;
		line-height: 3.8rem;
	`}
`;

const asHeading2 = css`
	${baseHeading}
	font-size: 2rem;
	font-weight: 900;
	line-height: 2.8rem;

	${media.tablet`
		font-size: 2.2rem;
		line-height: 3rem;
	`};

	${media.desktopSmall`
		font-size: 2.4rem;
		line-height: 3.4rem;
	`}
`;

const asHeading3 = css`
	font-size: 1.8rem;
	${baseHeading}
	font-weight: 700;
	line-height: 2.6rem;

	${media.tablet`
		font-size: 2rem;
		line-height: 3rem;
	`};
`;

const asHeading4 = css`
	${baseHeading}
	font-size: 1.6rem;
	font-weight: 700;
	line-height: 2.8rem;
`;

const asHeading5 = css`
	${baseHeading}
	font-size: 1.4rem;
	font-weight: 700;
	line-height: 2rem;
`;

const asHeading6 = css`
	${baseHeading}
	font-size: 1.2rem;
	font-weight: 700;
	line-height: 1.8rem;
`;

const H1 = styled.h1`${asHeading1}`;
const H2 = styled.h2`${asHeading2}`;
const H3 = styled.h3`${asHeading3}`;
const H4 = styled.h4`${asHeading4}`;
const H5 = styled.h5`${asHeading5}`;
const H6 = styled.h6`${asHeading6}`;

export {
	asHeading1,
	asHeading2,
	asHeading3,
	asHeading4,
	asHeading5,
	asHeading6,
	H1,
	H2,
	H3,
	H4,
	H5,
	H6
};
